import { GoodEndingTitleSection } from "./GoodEndingTitleSection"

export const GoodEndingHeader = () => {
  return (
    <GoodEndingTitleSection />
  )
}
